// ═══════════════════════════════════════════════════════════════════
//  modules/documents/Documents.js
//  Documents
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { THEME } from "../../socle/theme";
import { CloudModule } from "./CloudModule";
import { ComptaModule } from "./ComptaModule";
import { ComptesRendusModule } from "./ComptesRendusModule";
import { ContratsModule } from "./ContratsModule";
import { MarquesModule } from "./MarquesModule";
import { MerchModule } from "./MerchModule";

// ═══════════════ PAGE D'ACCUEIL DU MODULE ═══════════════
export function Documents({ token, user }) {
  const [sub,setSub]=useState("home");
  const CARDS=[
    { id:"compta",   icon:"💎", title:"Tenue de compte",        desc:"Dépenses, revenus, contributions, compte de résultat.", ready:true },
    { id:"cloud",    icon:"☁️", title:"Cloud officiel",          desc:"Dépôt de fichiers classés automatiquement par l'IA.",   ready:true },
    { id:"contrats", icon:"📜", title:"Contrats & prestataires", desc:"Mack, graphistes, avocat : objets, montants, échéances.", ready:true },
    { id:"marques",  icon:"🏷️", title:"Marques, domaines & PI",  desc:"Domaines, logos, alertes d'expiration.",                ready:true },
    { id:"cr",       icon:"📝", title:"Comptes-rendus",          desc:"Réunions et décisions importantes.",                    ready:true },
    { id:"merch",    icon:"🧸", title:"Catalogue merch",         desc:"Peluche Boux, porte-clés, marges & stock.",             ready:true },
  ];

  if (sub==="compta")   return <ComptaModule token={token} user={user} onBack={()=>setSub("home")} />;
  if (sub==="cloud")    return <CloudModule token={token} onBack={()=>setSub("home")} />;
  if (sub==="contrats") return <ContratsModule token={token} onBack={()=>setSub("home")} />;
  if (sub==="marques")  return <MarquesModule token={token} onBack={()=>setSub("home")} />;
  if (sub==="cr")       return <ComptesRendusModule token={token} onBack={()=>setSub("home")} />;
  if (sub==="merch")    return <MerchModule token={token} onBack={()=>setSub("home")} />;

  return (
    <div style={{display:"flex",flexDirection:"column",gap:18}}>
      <div>
        <h2 style={{color:THEME.text,fontSize:20,fontWeight:800,margin:0}}>📁 Documents</h2>
        <div style={{color:THEME.textMuted,fontSize:13,marginTop:4}}>Le centre névralgique du projet : comptabilité, fichiers officiels, contrats, marques & domaines.</div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill, minmax(280px, 1fr))",gap:14}}>
        {CARDS.map((c)=>(
          <button key={c.id} disabled={!c.ready} onClick={()=>c.ready&&setSub(c.id)}
            style={{textAlign:"left",cursor:c.ready?"pointer":"not-allowed",background:THEME.panel,border:`1px solid ${THEME.border}`,borderRadius:14,padding:18,display:"flex",flexDirection:"column",gap:8,opacity:c.ready?1:0.55,position:"relative"}}
            onMouseEnter={(e)=>{if(c.ready)e.currentTarget.style.borderColor=THEME.purple;}}
            onMouseLeave={(e)=>{e.currentTarget.style.borderColor=THEME.border;}}>
            <div style={{fontSize:30}}>{c.icon}</div>
            <div style={{color:THEME.text,fontSize:15,fontWeight:700}}>{c.title}</div>
            <div style={{color:THEME.textMuted,fontSize:12,lineHeight:1.4}}>{c.desc}</div>
            {!c.ready && <span style={{position:"absolute",top:14,right:14,fontSize:10,color:THEME.textDim,border:`1px solid ${THEME.border}`,borderRadius:6,padding:"2px 7px"}}>bientôt</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
